import { render, staticRenderFns } from "./BulletinItem.vue?vue&type=template&id=ec4d715a&scoped=true"
import script from "./BulletinItem.vue?vue&type=script&lang=js"
export * from "./BulletinItem.vue?vue&type=script&lang=js"
import style0 from "./BulletinItem.vue?vue&type=style&index=0&id=ec4d715a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d715a",
  null
  
)

export default component.exports